module.exports = __webpack_public_path__ + "static/media/gulp4.ea96a731.mp3";